import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';
import { settings } from '../common/staticData';

export default async (params = {}, signal = null) => {
  if (!settings.endpoint) {
    throw new CallError('params', {}, 400, { message: 'Missing value for app integrations endpoint' });
  }
  const requiredParams = ['appId'];
  const paramsRules = {
    appId: { allowedTypes: ['string'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  let content;
  const response = await fetch(`${settings.endpoint}/get-app-integrations`, {
    signal,
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ resultType: 'application/adobe.app.integration.full-v1+json', appNum: params.appId }),
  });
  const data = await response.text();
  try {
    content = JSON.parse(data);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  }

  return {
    apps: [
      { ...content, supportedProducts: (content?.supportedProducts ?? []).map((code) => ({ hostAppCode: code })) },
    ],
  };
};
